import setButtonDisabledState from './setButtonDisabledState';

/**
 * Utility function to reset button state made by setButtonStateDuringActivity utility function.
 * This is normally used after calling setButtonStateDuringActivity function that was invoked without passing a
 * Promise to manually reset the button state it had previously set.
 * @param {HTMLElement} buttonElement - The button DOM element.
 * @param {String} additionalClassNames - Additional class names that were added to the button and need to be removed,
 * 										  if any. Optional.
 */
function resetButtonStateAfterActivity (buttonElement: HTMLButtonElement, additionalClassNames: string = '') {

	if (!buttonElement) {

		return;

	}

	const defaultClassNames = [ 'loading', 'noPointerEvents' ];
	const classNames = additionalClassNames
		? [ ...defaultClassNames, ...additionalClassNames.split(' ') ]
		: defaultClassNames;

	function removeClassName () {

		// Cannot use spread operator due to IE not supporting multiple class names in classList.remove in one statement
		classNames.forEach((className) => buttonElement.classList.remove(className));

	}

	setButtonDisabledState(buttonElement, false);

	removeClassName();

}

export default resetButtonStateAfterActivity;
